export default {"theme":{"disable":true},"options":{"themeCache":{"get":() => ''}}}
